import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CardDisplay from '@components/CardDisplay';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import LazyLoad from 'react-lazyload';
import { useTranslation } from 'next-i18next';
import cx from 'classnames';

const useStyles = makeStyles(theme => ({
  rooCardDisplay: {
    border: '1px solid #E1E4EB',
    '&:hover': {
      boxShadow:
        '0 2px 4px -1px rgb(0 0 0 / 4%), 0 4px 5px 0 rgb(0 0 0 / 7%), 0 1px 10px 0 rgb(0 0 0 / 11%)',
    },
    width: ({ direction }) => (direction === 'horizontal' ? '100%' : '100%'),
    [theme.breakpoints.up('md')]: {
      width: ({ direction }) => (direction === 'horizontal' ? '100%' : 232),
    },
  },
  contentContainer: {
    display: ({ direction }) => (direction === 'horizontal' ? 'flex' : 'block'),
    cursor: 'pointer',
  },
  contentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    padding: 15,
    width: '100%',
    justifyContent: 'space-between',
    height: ({ direction }) => (direction === 'horizontal' ? 'initial' : 108),
  },
  productImage: {
    backgroundColor: '#F4F5F8',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    width: ({ direction }) => (direction === 'horizontal' ? 150 : '100%'),
    height: ({ direction }) => (direction === 'horizontal' ? 150 : 150),
    [theme.breakpoints.up('sm')]: {
      height: ({ direction }) => (direction === 'horizontal' ? 150 : 232),
    },
    [theme.breakpoints.up('md')]: {
      width: ({ direction }) => (direction === 'horizontal' ? 150 : 232),
    },
    flex: '1 0 150px',
  },
  productName: {
    fontSize: 16,
    color: '#31415E',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': 3,
    display: '-webkit-box',
    textAlign: 'left',
    lineBreak: 'anywhere',
  },
  soldOutLabel: {
    color: '#fff',
    backgroundColor: '#FE3D4C',
    borderRadius: 18,
    padding: '6px 12px',
    textAlign: 'center',
    width: 120,
  },
  price: { fontSize: 16, color: '#31415E', textAlign: 'left' },
}));

const ProductItem = ({
  direction = 'horizontal',
  price,
  productName,
  productImage = '/static/images/placeholderImage.png',
  slug = '',
  locale = 'en',
  domain = '',
  isAvailable = true,
}) => {
  const classes = useStyles({ direction });
  const { t } = useTranslation('common');
  return (
    <CardDisplay noPadding classes={{ root: classes.rooCardDisplay }}>
      <a href={locale === 'en' ? `${domain}/p/${slug}` : `${domain}/${locale}/p/${slug}`}>
        <div className={classes.contentContainer}>
          <LazyLoad height={150}>
            <div
              className={classes.productImage}
              style={{
                backgroundImage: `url(${productImage || '/static/images/product-placeholder.jpg'})`,
              }}
            ></div>
          </LazyLoad>
          <div className={classes.contentWrapper}>
            <div>
              <Typography className={classes.productName}>{productName}</Typography>
            </div>
            {isAvailable ? (
              price !== 'RM0.00' ? (
                <div>
                  <Typography className={classes.price}>{price}</Typography>
                </div>
              ) : (
                ''
              )
            ) : (
              <Typography className={classes.soldOutLabel}>{t('item-out-of-stock')}</Typography>
            )}
          </div>
        </div>
      </a>
    </CardDisplay>
  );
};

ProductItem.propTypes = {
  price: PropTypes.string,
  productImage: PropTypes.string,
  productName: PropTypes.string,
  slug: PropTypes.string,
  locale: PropTypes.string,
  domain: PropTypes.string,
  isAvailable: PropTypes.bool,
  direction: 'horizontal' || 'vertical',
};

export default ProductItem;
